export const getReferrer = () => {
  if (typeof window === 'undefined') {
    return ''
  }

  const { location, document } = window
  let queryReferrer = ''

  try {
    const search = location?.search ?? ''
    const params = new URLSearchParams(search)
    const value = params.get('referrer')

    if (value && value.trim().length > 0) {
      queryReferrer = value
    }
  } catch (_error) {
    queryReferrer = ''
  }

  if (queryReferrer) {
    return queryReferrer
  }

  return document?.referrer || ''
}

